(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/pay-numbergames/assets/javascripts/dialogs/closed-joker-draw.js') >= 0) return;  svs.modules.push('/components/numbergames/pay-numbergames/assets/javascripts/dialogs/closed-joker-draw.js');

'use strict';

const productMapping = svs.numbergames.productMapping;

function closedJokerDrawDialog(_ref) {
  let next = _ref.next,
    cancel = _ref.cancel,
    productWithClosedJoker = _ref.productWithClosedJoker;
  const product = productMapping.getProductName(productWithClosedJoker);
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    icon: 'exclamation-sign',
    title: 'Spelstopp Joker har passerat',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: "Men du kan spela utan Joker fram till spelstopp ".concat(product, " idag")
    }],
    actions: [{
      title: 'Avbryt',
      callback: (e, forms, dialog) => {
        dialog.close();
        cancel();
      }
    }, {
      title: 'Fortsätt',
      callback: (e, forms, dialog) => {
        dialog.close();
        next();
      }
    }]
  }));
}
svs.numbergames.pay_numbergames.closedJokerDrawDialog = closedJokerDrawDialog;

 })(window);